import Vue from "vue"
import VueRouter from "vue-router"
import util from "@/assets/util"
import wx from 'weixin-js-sdk'
Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
	return originalPush.call(this, location).catch((err) => err)
}
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace (location){
	return originalReplace.call(this, location).catch(err=>err)
}

const routeMap = {
	"/": "../views/Index",
	"/login": "../views/Login",
	"/leaderEnd": "../views/HomeView",
	"/myWork": "../views/MyWork",
	"/myProject": "../views/MyProject",
	"/newEnterprise": {
		list: "../views/newEnterprise/List",
		detail: "../views/newEnterprise/Detail",
		form: "../views/newEnterprise/Form",
	},
	"/negotiation": {
		detail: "../views/negotiation/Detail",
	},
	"/income": {
		list: "../views/income/List",
		detail: "../views/income/Detail",
	},
	"/economy": {
		index: "../views/economy/Index",
		list: "../views/economy/List",
		statistic: "../views/economy/indicator/Index",
		indicatorDetail: "../views/economy/indicator/indicatorDetail",
		detail: "../views/economy/Detail",
	},
	"/clockIn": {
		index: "../views/clockIn/Index",
	},
	"/specialClassSearch": {
		home: "../views/specialClassSearch/Index",
	},
	"/homeSearch": {
		index: "../views/homeSearch/Index",
	},
	"/my": {
		myPendingList: "../views/my/task/MyPendingList",
		myRemindList: "../views/my/remind/MyRemindList",
		remindDetail: "../views/my/remind/RemindDetail",
		taskDetail: "../views/my/task/TaskDetail",
		addRemind: "../views/my/remind/AddRemind",
		handleAction: "../views/my/task/HandleAction",
		myAppeal: "../views/my/appeal/MyAppeal",
		appealDetail: "../views/my/appeal/AppealDetail",
		remark: "../views/my/appeal/Remark",
		myMsg: "../views/MyMsg",
		myEnterpriseList: "../views/my/enterprise/MyEnterpriseList",
		enterpriseDetail: "../views/my/enterprise/EnterpriseDetail",
	},
	"/redCard": {
		list: "../views/redCard/List",
		detail: "../views/redCard/Detail",
	},
	"/statistic": "../views/statistic/Index",
	"/duty": {
		workbench: "../views/dutyEnd/Workbench",
		myTaskList: "../views/dutyEnd/my/MyTaskList",
		taskDetail: "../views/dutyEnd/my/TaskDetail",
		applyAudit: "../views/dutyEnd/components/ApplyAudit",
		remindList: "../views/dutyEnd/remind/List",
		remindDetail: "../views/dutyEnd/remind/RemindDetail",
		replyRemind: "../views/dutyEnd/remind/ReplyRemind",
		addProcess: "../views/dutyEnd/components/AddProcess",
		unReplyRemind: "../views/dutyEnd/remind/UnReplyRemind",
		myAppeal: "../views/dutyEnd/my/MyAppeal",
		myMsg: "../views/MyMsg",
	},
	"/landRevital": {
		List: "../views/landRevital/List",
		detail: "../views/landRevital/Detail",
	},
	"/waterway": {
		List: "../views/waterway/List",
		detail: "../views/waterway/Detail",
	},
	"/majorelements": {
		List: "../views/majorelements/List",
		form: "../views/majorelements/Form",
		detail: "../views/majorelements/Detail",
	},
	"/saveMessageToLeader": {
		list: "../views/saveMessageToLeader/List",
		detail: "../views/saveMessageToLeader/SaveMessageToLeaderDetail",
	},
	"/rankList": "../views/rank/RankList",
	"/unitTask": "../views/unitTask/Index",
	"/enterpriseHome": {
		"/": "../views/enterpriseHome/home/Index",
		login: "../views/enterpriseHome/Login",
		newAreaOverview: "../views/enterpriseHome/newAreaOverview/Index",
		inAndOutEnterprise:
			"../views/enterpriseHome/newAreaOverview/InAndOutEnterprise",
		newAreaDynamics: "../views/enterpriseHome/newAreaDynamics/Index",
		newAreaDynamicsDetail:
			"../views/enterpriseHome/newAreaDynamics/NewAreaDynamicsDetail",
		appealHome: "../views/enterpriseHome/appeal/Index",
		appealForm: "../views/enterpriseHome/appeal/AppealForm",
		questionList: "../views/enterpriseHome/appeal/QuestionList",
		appealDetail: "../views/enterpriseHome/appeal/AppealDetail",
		remark: "../views/enterpriseHome/appeal/Remark",
		myAppeal: "../views/enterpriseHome/appeal/MyAppeal",
		policy: "../views/enterpriseHome/policy/Policy",
		policyDetail: "../views/enterpriseHome/policy/Detail",
		policyApply: "../views/enterpriseHome/policy/Apply",
		my: "../views/enterpriseHome/my/Index",
		projDetail: "../views/enterpriseHome/my/MyProj/Detail",
		policyApplyDetail: "../views/enterpriseHome/my/PolicyApplyDetail"
	},
	"/myTask": "../views/TaskListHandleByWX",
	"/applet": {
		"appeal": "../views/applet/appeal/Index",
		"hotAppealList": "../views/applet/appeal/HotAppealList",
		"newAreaDynamics": "../views/applet/newAreaDynamics/Index",
		"newAreaDynamicsDetail": "../views/applet/newAreaDynamics/NewAreaDynamicsDetail",
		"sendMessageToLeader": "../views/applet/appeal/SendMessageToLeader",
		"enterpriseAppealApply": "../views/applet/appeal/EnterpriseAppealApply",
		"enterpriseAppealDetail": "../views/applet/appeal/EnterpriseAppealDetail",
		"policy": "../views/applet/policy/Index",
		"policyDomain": "../views/applet/policy/ProjectPolicy",
		"projectPolicyDetail": "../views/applet/policy/ProjectPolicyDetail",
		"projectPolicyApply": "../views/applet/policy/ProjectPolicyApply",
		"policyApplyDetail": "../views/applet/policy/PolicyApplyDetail",
		"policyReadDetail": "../views/applet/policy/PolicyReadDetail",
		"myProject": "../views/applet/myProject/Index",
		"projDetail": "../views/applet/myProject/Detail",
		"myAppeal": "../views/applet/myAppeal/Index",
		"myMessageToLeaderDetail": "../views/applet/myAppeal/MyMessageToLeaderDetail",
		"enterpriseOpen": "../views/applet/EnterpriseOpen",
		"projectBuild": "../views/applet/ProjectBuild",
		"myCollection": "../views/applet/myCollection/Index",
		"myPolicy": "../views/applet/myCollection/PolicyDynan",
		"enterpriseSupermarket": "../views/applet/enterpriseSupermarket/Index",
		"myDemand": "../views/applet/enterpriseSupermarket/MyDemand",
		"demanDetail": "../views/applet/enterpriseSupermarket/DemanDetail",
		"publishDeman": "../views/applet/enterpriseSupermarket/PublishDeman",
		"myProduct": "../views/applet/enterpriseSupermarket/MyProduct",
		"productDetail": "../views/applet/enterpriseSupermarket/ProductDetail",
		"publishProduct": "../views/applet/enterpriseSupermarket/PublishProduct",
		"weiXinEnterpriseSupermarket": "../views/applet/weiXinEnterpriseSupermarket/Index",
		"myAppealList": "../views/applet/myAppeal/MyAppealList",
		"myQuestion": "../views/applet/appeal/myQuestion",
		"myQuestionDetail": "../views/applet/appeal/myQuestionDetail",
	},
}

const routes = util.convertRouteMap(routeMap, function (module) {
	if (module.startsWith("../")) {
		return import(`../${module.substr(3)}`)
	}
	return import(`${module}`)
})
const router = new VueRouter({
	routes,
})

const titleMap = {
	"/myWork?type=associate": "我挂钩的项目",
	"/myProject": "我负责的项目",
	"/my/myPendingList": "待协调解决事项",
	"/my/myRemindList": "我督办的事项",
	"/my/myAppeal": "待处理诉求",
	"/statistic": "招商引资",
	"/negotiation/detail": "挂钩项目",
	"/landRevital/List": "用地盘活",
	"/waterway/List": "百千万工程",
	"/majorelements/List": "社会治理",
	"/income/list": "谋收入",
	"/homeSearch/index": "搜索",
	"/leaderEnd": "江东新区“e江通”政企服务平台",
	"/my/taskDetail": "待协调事项",
	"/my/remindDetail": "督办项目",
	"/my/myMsg": "我的消息",

	"/duty/workbench": "江东新区“e江通”政企服务平台",
	"/duty/myTaskList": "我的任务",
	"/duty/remindList": "督办事项",
	"/duty/myAppeal": "待处理诉求",
	"/duty/taskDetail": "我的任务",

	"/rankList?rankingType=good": "火箭榜",
	"/rankList?rankingType=bad": "蜗牛榜",
	"/saveMessageToLeader/list": "群众诉求",
}
router.beforeEach((to, from, next) => {
	if(to.path === '/redCard/list') document.title = to.query.itemName //路径有中文特殊处理
	if(titleMap[to.path] || titleMap[to.fullPath]) document.title = titleMap[to.path] || titleMap[to.fullPath]
	// 门户需要校验的路由，需要先登录
	const portalInterceptList = [
		"/enterpriseHome/appealForm",
		"/enterpriseHome/my",
	]
	// 小程序登录验证
	const appletVerifyList = [
		"/applet/appeal",
		"/applet/hotAppealList",
		"/applet/newAreaDynamics",
		"/applet/newAreaDynamicsDetail",
		"/applet/sendMessageToLeader",
		"/applet/enterpriseAppealApply",
		"/applet/enterpriseAppealDetail",
		"/applet/policy",
		"/applet/policyDomain",
		"/applet/projectPolicyDetail",
		"/applet/projectPolicyApply",
		"/applet/enterpriseOpen",
		"/applet/projectBuild",
		"/applet/appealForm",
		"/applet/myProject",
		"/applet/projDetail",
		"/applet/myAppeal",
		"/applet/myMessageToLeaderDetail",
		"/applet/enterpriseSupermarket",
		"/applet/demanDetail",
		"/applet/publishDeman",
		"/applet/productDetail",
		"/applet/publishProduct",
		"/applet/myPolicy",
		"/applet/myDemand",
		"/applet/myProduct",
		"/applet/myAppealList",
		"/applet/weiXinEnterpriseSupermarket",
		"/applet/myQuestion"
		
	]
	if(appletVerifyList.includes(to.path)) {
		let ua = navigator.userAgent.toLowerCase()
		if(to.query.token) {
			sessionStorage.setItem("appletToken", to.query.token)
			sessionStorage.setItem("enterpriseName", to.query.enterpriseName)
			sessionStorage.setItem("uniformCode", to.query.uniformCode)
			sessionStorage.setItem("enterpriseCreditCode", to.query.uniformCode)
			sessionStorage.setItem("username", to.query.username)
			sessionStorage.setItem("mobile", to.query.mobile)
		}
		if(ua.match(/MicroMessenger/i) == "micromessenger"){
			wx.miniProgram.getEnv((res)=>{
				if (res.miniprogram && !sessionStorage.getItem("appletToken")) {
					// wx.miniProgram.navigateTo({
					// 	url: '/pages/login/index'
					// })
					next()
				}else{
					next()
				}
			})
		}else{
			next()
		}

	} else if (
		portalInterceptList.includes(to.path) &&
		!sessionStorage.getItem("loginid")
	) {
		next({
			path: "/enterpriseHome/login",
			query: {
				nextUrl: to.path,
			},
		})
	}else{
		//非门户校验
		let token = sessionStorage.getItem("PAuthToken")
		let wxwork = sessionStorage.getItem("wxwork")
		if (
			(!token || token == "" || token == undefined) 
			&& to.fullPath != "/login" 
			&& to.fullPath != "/myTask" 
			&& !to.fullPath.includes("enterpriseHome") 
			&& !to.fullPath.includes("applet") 
			&& !wxwork 
		) {
			next({ path: "/login" })
		} else {
			// 获取角色，责任人不能访问领导端，领导端不能访问责任人端
			let roleType = sessionStorage.getItem("OrignalProleType")
			if((roleType === 'normal' && to.fullPath === "/leaderEnd") || (roleType === 'leader' && to.fullPath === "/duty/workbench")){
				return
			}
			console.log(to.fullPath)
			next()
		}
	}

	// let token = sessionStorage.getItem("SAuthToken")
	// if (
	// 	(!token || token == "" || token == undefined) &&
	// 	to.fullPath != "/login"
	// ) {
	// 	next({ path: "/login" })
	// } else {
	// 	next()
	// }
})

export default router
